type Env = 'development' | 'staging' | 'production';

export const getEnv = (): Env => {
  if (typeof location === 'undefined') {
    return 'development';
  }

  if (location.host.includes('localhost') || location.host.includes('ngrok.io')) {
    return 'development';
  }

  if (location.host.includes('stg')) {
    return 'staging';
  }

  return 'production';
};

export const isProduction = (): boolean => getEnv() === 'production';

export const isStaging = (): boolean => getEnv() === 'staging';

export const isDevelopment = (): boolean => getEnv() === 'development';
